<template>
  <div v-loading="loading">
    <div class="header">
      <el-space>
        <el-input
            v-model="search"
            style="width: 250px;"
            placeholder="Izlash"
            clearable
            @clear="onSearch"
        >
          <template #append>
            <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt=""/>
            </el-button>
          </template>
        </el-input>
        <el-select
            v-model="category_id"
            placeholder="Kategoriya"
            @change="onChangeCategory"
        >
          <el-option
              v-for="category in categories"
              :value="category.id"
              :key="category.title"
              :label="category.title"
          />
        </el-select>
        <el-select v-model="board_id" style="width: 280px" @change="onchangeBoard">
          <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
          />
        </el-select>
      </el-space>
      <el-space>
        <el-upload
            v-model:file-list="fileList"
            class="upload-demo"
            :action="url + 'api/v1/products/sync-excel'"
            :data="{board_id:board_id}"
            :headers="uploadHeader"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :limit="1"
            :on-success="handleSucces"
            :on-error="handleFail"
            :on-exceed="handleExceed"
        >
          <el-button type="primary">Excell yuklash</el-button>
        </el-upload>
        <el-button type="warning" @click="getExcell()">Excell olish</el-button>
        <el-button type="primary" @click="$router.push({ name: 'ProductsAdd' })"
        >Qo'shish
        </el-button
        >
      </el-space>
    </div>
    <el-table
        class="table-body"
        :data="tableData"
        border
        height="calc(100vh - 247px)"
    >
      <el-table-column type="index" label="T/r" :index="indexMethod"/>
      <el-table-column prop="category" label="Kategoriya"/>
      <el-table-column prop="title" label="Nomi"/>
      <el-table-column prop="price" label="Narxi"/>
      <el-table-column prop="max_available" label="Soni"/>
      <el-table-column prop="unit_of_measure" label="O'chov birligi"/>
      <el-table-column align="center">
        <template #default="scope">
          <el-button
              size="small"
              type="danger"
              @click="deleteBudgetParam(scope.row.id)"
          >O'chirish
          </el-button>
          <el-button
              size="small"
              type="primary"
              @click="
              $router.push({
                name: 'ProductsEdit',
                params: { id: scope.row.id },
              })
            "
          >Tahrirlash
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalElements">Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              layout=" prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import http from "@/http";

export default {
  name: "ProductsList",
  data() {
    return {
      loading: false,
      tableData: [],
      categories: [],
      category_id: "",
      search: "",
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      url: process.env.VUE_APP_BASE_API_URL,
      board_id: null,
      boards: [],

      totalElements: 0,
      totalPages: null,
      size: 20,
      page: 1,
    };
  },
  computed: {
    uploadHeader() {
      return {
        Authorization: this.$store.state.accessToken,
      };
    },
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  methods: {
    onChangeCategory() {
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    onchangeBoard() {
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    getBoards() {
      this.loading = true;
      http({url: `api/v1/boards`, params: {status: 1}})
          .then(({data}) => {
            this.boards = data.boards;
            this.board_id = data.boards[0].id;
            if (this.board_id) {
              this.getProducts();
            }
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
            this.loading = false;
          })
    },
    onSearch() {
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    getExcell() {
      this.loading = true;
      http
          .get("api/v1/products/excel", {
            params: {
              board_id: this.board_id,
            },
            responseType: 'blob'
          })
          .then((response) => {
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "tovarlar.xlsx"); // or dynamically set the filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            ElMessage({
              type: "success",
              message: "Muvaffaqqiyatli yuklandi",
            });
          })
          .catch(({response}) => {
            ElNotification.error({
              message: response.data.message || "Xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSucces() {
      this.getProducts();
      ElMessage({
        type: "success",
        message: "Muvaffaqqiyatli yuklandi",
      });
    },
    handleFail() {
      ElNotification({
        type: "error",
        title: "Xatolik",
        message: "Iltimos, qayta urinib ko'ring",
      });
    },
    getProducts() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.$http
          .get(
              `api/v1/products`,
              {
                params: {
                  category_id: this.category_id,
                  search: this.search,
                  board_id: this.board_id,
                  limit: this.size,
                  offset: (this.page - 1) * this.size
                }
              }
          )
          .then(({data}) => {
            this.tableData = data.products;
            this.totalElements = data.count;
            this.totalPages = Math.ceil(data.count / this.size);
            this.tableData.forEach((product) => {
              if (product.unit_of_measure === "collection") {
                product.unit_of_measure = "To'plam";
              }
              if (product.unit_of_measure === "piece") {
                product.unit_of_measure = "Dona";
              }
              if (product.unit_of_measure === "package") {
                product.unit_of_measure = "Quti";
              }
            });
          })
          .catch(({response}) => {
            ElNotification.error({
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    deleteBudgetParam(id) {
      ElMessageBox.confirm("Parametrni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`api/v1/products/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getProducts();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },

    indexMethod(index) {
      return index + (this.currentPage - 1) * this.size + 1;
    },
  },
  mounted() {
    this.getBoards()

    http.get("api/v1/product-categories").then((res) => {
      this.categories = res.data.product_categories;
    });
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 20px;

  .filter {
    display: flex;
    justify-content: flex-start;
  }
}

.table-body {
  img {
    width: 80px;
  }
}

.upload-demo {
  margin-bottom: -10px;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.pagination-wrapper > span {
  color: #0A194E;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
